<template>  
  <v-container fluid grid-list-lg class="ma-0 pa-0">
    <v-card>
      <v-toolbar dense flat >        
        <v-toolbar-title>Report Responden</v-toolbar-title>
        <v-spacer/>
        <v-btn color="success" dark @click="export2excel()">
          <v-icon left>select_all</v-icon>.xls
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-layout row>
          <v-flex xs6 md3 lg2>
            <v-autocomplete outlined dense hide-no-data hide-details
              v-model="fm.jilid_id"
              label="Survey"
              :items="jilids"
              item-text="name"
              item-value="id"
              :loading="jilidLoading"        
              style="background:#fff; max-width:250px"
              autocomplete="off"
              @keyup="serachJilid"
            />        
          </v-flex>
          <v-flex xs6 md3 lg2 v-if="!disabled.addr_idkab">
            <v-autocomplete outlined dense hide-no-data hide-details
              v-model="fm.addr_idpro"
              label="Provinsi"
              :items="provinsi"
              item-text="name"
              item-value="id"
              :loading="provinsiLoading"
              :disabled="disabled.addr_idpro"
              clearable
              autocomplete="off"
            />
          </v-flex>
          <v-flex xs6 md3 lg2>  
            <v-autocomplete outlined dense hide-no-data hide-details
              v-model="fm.addr_idkab"
              label="Kabupaten/Kota"
              :items="kabupaten"
              item-text="name"
              item-value="id"
              :loading="kabupatenLoading"
              :disabled="disabled.addr_idkab"
              clearable autocomplete="off"
            />
          </v-flex>
          <v-flex xs6 md3 lg2>  
            <v-autocomplete outlined dense hide-no-data hide-details
              v-model="fm.addr_idkec"
              label="Kecamatan"
              :items="kecamatan"
              item-text="name"
              item-value="id"
              :loading="kecamatanLoading"
              :disabled="disabled.addr_idkec"
              clearable autocomplete="off"
            />
          </v-flex>
          <v-flex xs6 md3 lg2>  
            <v-autocomplete outlined dense hide-no-data hide-details
              v-model="fm.addr_idkel"
              label="Kelurahan"
              :items="kelurahan"
              item-text="name"
              item-value="id"
              :loading="kelurahanLoading"
              :disabled="disabled.addr_idkel"
              clearable autocomplete="off"
            />
          </v-flex>    
           <v-flex xs6 md3 lg2>  
            <v-select outlined dense hide-no-data hide-details
              v-model="sortby"
              label="Urutan"
              :items="sorter"
              item-text="name"
              item-value="id"
              autocomplete="off"
            />
          </v-flex>            
          <v-flex xs1>
            <v-btn @click="submitReport()">filter</v-btn>
          </v-flex>
        </v-layout>        
      </v-card-text>
      <v-divider/>
      <v-card-text>      
        <v-layout row>
          <v-flex xs12 md3>
            <v-text-field flat dense filled
              v-model="term"
              append-icon="search"
              label="Search"
              single-line
              hide-details        
              @input="search"
              style="max-width:250px"
            ></v-text-field>                       
          </v-flex>
          <v-flex xs9 md4>
            <v-radio-group v-model="fm.type" label="Answer Type :" class="mt-0" row>
              <v-radio label="id" :value="1"></v-radio>
              <v-radio label="key" :value="2"></v-radio>
              <v-radio label="value" :value="3"></v-radio>                                        
            </v-radio-group>
          </v-flex>
          <v-flex xs3 md2>
            <v-checkbox v-model="fm.alamat" label="alamat" class="mt-0" />            
          </v-flex>
        </v-layout>        
      </v-card-text>
      <v-card-text>      
        <v-container fluid grid-list-lg class="ma-0 pa-0">
          <v-layout row>
            <v-flex xs12>
              <v-progress-linear
                v-if="loadstart"
                v-model="persen"
                height="25"
                reactive
                color="green"
                stream striped                
              >
                <strong>load data {{ Math.ceil(persen) }}%</strong>
              </v-progress-linear>
              <v-skeleton-loader  v-if="loading"         
                type="card, actions"
                style="width:100%"
              ></v-skeleton-loader>
            </v-flex>
            <v-flex xs12 class="v-data-table__wrapper" style="position:relative; overflow-x: auto;" id="export" v-if="persen > 0">
              <table class="tb-normal">
                <thead>
                  <tr>
                    <th rowspan="2">No</th>                    
                    <th rowspan="2">Code</th>
                    <th rowspan="2">Date</th>
                    <th rowspan="2">Name</th>
                    <th rowspan="2">G</th>
                    <th rowspan="2">Phone</th>
                    <template v-if="fm.alamat">
                      <th rowspan="2">Address</th>
                      <th rowspan="2">Propinsi</th>
                      <th rowspan="2">Kabupaten</th>
                      <th rowspan="2">Kecamatan</th>
                      <th rowspan="2">Kelurahan</th>
                      <th rowspan="2">Tps</th>
                    </template>
                    <th :colspan="items[0] && items[0].responDtls ? items[0].responDtls.length : 0">Pertanyaan</th>
                    <th rowspan="2">Surveyor</th>
                    <th rowspan="2" style="min-width:130px">Created at</th>
                    <th rowspan="2">isOnline</th>
                  </tr>
                  <tr v-if="items[0] && items[0].responDtls">
                    <th v-for="(item,i) in items[0].responDtls" :key="i">
                      {{item.no}}                    
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(respon, i ) in items">
                    <tr :key="i">
                      <td valign="top">{{i+1}}</td>
                      <td valign="top">{{respon.code}}</td>
                      <td valign="top">{{respon.date}}</td>
                      <td valign="top">{{respon.name}}</td>
                      <td valign="top">{{respon.gender}}</td>
                      <td valign="top">{{respon.phone}}</td>
                      <template v-if="fm.alamat">
                        <td valign="top">{{respon.address}}</td>
                        <td valign="top">{{respon.propinsi ? respon.propinsi.name : respon.addr_idpro}}</td>
                        <td valign="top">{{respon.kabupaten ? respon.kabupaten.name : respon.addr_idkab}}</td>
                        <td valign="top">{{respon.kecamatan ? respon.kecamatan.name : respon.addr_idkec}}</td>
                        <td valign="top">{{respon.kelurahan ? respon.kelurahan.name : respon.addr_idkel}}</td>
                        <td valign="top">{{respon.tps ? respon.tps.name : respon.tps_id}}</td>
                      </template>  
                      <template v-for="(item, j) in respon.responDtls">
                        <td :key="j" valign="top">
                          <template v-if="fm.type===1">
                            <span v-if="item.type === 1">{{item.answer_id}}</span>
                            <span v-if="item.type === 2">                          
                              <span v-for="(ans, k) in item.answer_jsonid" :key="k" v-if="ans">
                                {{ans}},
                              </span>
                            </span>                            
                          </template>
                          <template v-if="fm.type===2">
                            <span v-if="item.type === 1">{{Array.isArray(item.option) && item.option.find(x=>x.id===item.answer_id) ? item.option.find(x=>x.id===item.answer_id).key : ''}}</span>
                            <span v-if="item.type === 2">                          
                              <span v-for="(ans, k) in item.answer_jsonid" :key="k" v-if="ans">
                                {{Array.isArray(item.option) &&  item.option.find(x=>x.id===ans) ? item.option.find(x=>x.id===ans).key : ''}},
                              </span>
                            </span>
                          </template>
                          <template v-if="fm.type===3">
                            <span v-if="item.type === 1">{{Array.isArray(item.option) && item.option.find(x=>x.id===item.answer_id) ? item.option.find(x=>x.id===item.answer_id).value : ''}}</span>
                            <span v-if="item.type === 2">                          
                              <span v-for="(ans, k) in item.answer_jsonid" :key="k" v-if="ans">
                                {{Array.isArray(item.option) &&  item.option.find(x=>x.id===ans) ? item.option.find(x=>x.id===ans).value : ''}},
                              </span>
                            </span>
                          </template>
                          <template v-if="fm.type===2">
                            <span v-if="item.type === 1">{{item.answer_value}}</span>
                            <span v-if="item.type === 2">                          
                              <span v-for="(ans, k) in item.answer_jsonvalue" :key="k" v-if="ans">
                                {{ans}},
                              </span>
                            </span>
                          </template>
                          <span v-if="item.type === 3">
                            <span v-for="(ans, k) in item.answer_jsonvalue" :key="k" v-if="ans">
                              {{ans}},
                            </span>
                          </span>                            
                        </td>
                      </template>
                      <td valign="top">{{respon.createdby?respon.createdby.username:null}}</td>
                      <td valign="top">{{$moment(respon.created_at*1000).format('DD-MM-YYYY HH:mm')}}</td>
                      <td valign="top">{{respon.client_id ? 'offline':'online'}}</td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </v-flex>                
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card> 
  </v-container>  
</template>

<script>
import { debounce } from 'lodash'
import Model from '@/app/models/Report'
const  model = new Model()
import Table2Excel  from 'table2excel.js';  

export default {
  data () {
    return {
      term : null,
      fm:{jilid_id:null, type:1, alamat:false, addr_idpro:null, addr_idkab:null, addr_idkec:null, addr_idkel:null},
      disabled : {addr_idpro : false, addr_idkab: false, addr_idkec: false, addr_idkel:false},
      provinsi  : [], kabupaten : [], kecamatan : [], kelurahan : [], tps:[],
      provinsiLoading  : false, kabupatenLoading : false, kecamatanLoading : false, kelurahanLoading : false, tpsLoading:false,      
      jilids:[], jilidLoading:false, jilid:{},      
      items: [],               
      loading: false, persen:0, loadstart:false, 
      sorter:[{id:1,name:'by date'},{id:2,name:'by area'}],   
      sortby:1,
    }
  },
  computed:{
    status(){
      return this.$store.getters.DICTIONS.JilidStatus;      
    },    
  },
  watch:{
    'fm.addr_idpro'(newId){if(newId){      
      model.node({id:newId,jilid_id:this.jilid.id,expand:'lembar,lembarDone'}).then(res=>{this.provinsi.push(res)});
      this.kabupatenLoading = true; //this.fm.addr_idkab = null;
      model.kabupaten({parent:newId,jilid_id:this.jilid.id,expand:'lembar,lembarDone'}).then(data=>{
        this.kabupaten=data; this.kabupatenLoading = false;  
        this.fm.addr_idkab = this.fm.addr_idkab && data.find(x=>x.id === this.fm.addr_idkab) ? this.fm.addr_idkab : null;         
      })
    }},
    'fm.addr_idkab'(newId){
      if(newId){      
        this.kecamatanLoading = true;
        model.kecamatan({parent:newId,jilid_id:this.jilid.id,expand:'lembar,lembarDone'}).then(data=>{
          this.kecamatan=data; this.kecamatanLoading = false;
          this.fm.addr_idkec = this.fm.addr_idkec && data.find(x=>x.id===this.fm.addr_idkec) ? this.fm.addr_idkec:null;
          if(this.kecamatan.find(x=>x.id===this.fm.addr_idkec)){
            this.fm.addr_postcode = this.fm.addr_postcode ? this.fm.addr_postcode:this.kecamatan.find(x=>x.id===this.fm.addr_idkec).kodepos;
          }  
        })
        model.node({id:newId,jilid_id:this.jilid.id,expand:'lembar,lembarDone'}).then(data=>{this.fm.addr_idpro = data.parent_id;})
      } else {
        this.fm.addr_idkec = null; this.kecamatan = []; 
      }
    },
    'fm.addr_idkec'(newId){
      if(newId){      
        this.kelurahanLoading = true; 
        model.kelurahan({parent:newId,jilid_id:this.jilid.id,expand:'lembar,lembarDone'}).then(data=>{
          this.kelurahan=data; this.kelurahanLoading = false;
          this.fm.addr_idkel = this.fm.addr_idkel && data.find(x=>x.id===this.fm.addr_idkel) ? this.fm.addr_idkel : null;           
        })      
        if(this.kecamatan.find(x=>x.id===newId)){
          let kodepos = this.kecamatan.find(x=>x.id===newId).kodepos;
          this.fm.addr_postcode = this.fm.addr_postcode ? this.fm.addr_postcode : kodepos; 
        }  
      } else {
        this.fm.addr_idkel = null; this.kelurahan = [];
      }
    },   
    'fm.addr_idkel'(newId, oldId){if(oldId===null && newId !== null){
      this.tpsLoading = true;
      model.node({id:newId,jilid_id:this.jilid.id,expand:'lembar,lembarDone'}).then(data=>{
        this.kelurahan.push(data); 
        /*model.tps({idkel:data.id}).then(res=>{
          this.tps = res.data;
          this.tpsLoading = false;
        })*/
      })  
    } else if(this.kelurahan.find(x=>x.id===newId)){
      this.tpsLoading = true;
      model.tps({idkel:newId}).then(res=>{
        this.tps = res.data;
        this.tpsLoading = false;
      })
    }},
    'fm.jilid_id'(){
      this.init();
    }
  },  
  mounted(){    
    model.jilids().then(res=>{
      this.jilids = res.data;
      if(this.$route.query.id){
        this.fm.jilid_id = this.$route.query.id;
      } else if(this.jilids[0]){
        this.fm.jilid_id = this.jilids[0].id;
      }      
      this.init();
    });    
  },
  methods: {
    serachJilid : debounce(function(e){
      this.jilid = [];
      this.jilidLoading = true
      model.jilids({q:e.target.value}).then(res=>{
        this.jilids = res.data;
        this.jilidLoading = false                
      });  
    }, 200),

    init(){
      this.jilid = this.jilids.find(x=>x.id==this.fm.jilid_id);
      if(this.jilid && this.jilid.node_id){
        model.node({id:this.jilid.node_id,jilid_id:this.jilid.id,expand:'lembar,lembarDone'}).then(res=>{
          if(res.level){
            this.disabled.addr_idpro = false;
            this.disabled.addr_idkab = false;
            this.disabled.addr_idkec = false;
            this.disabled.addr_idkel = false;
            this.fm.addr_idpro = null;
            this.fm.addr_idkab = null;
            this.fm.addr_idkec = null;
            this.fm.addr_idkel = null;

            switch(parseInt(res.level)){
              case 1: this.fm.addr_idpro = res.id; 
                this.disabled.addr_idpro = true;
                break;
              case 2: this.fm.addr_idkab = res.id; 
                this.disabled.addr_idpro = true;
                this.disabled.addr_idkab = true;
                break;
              case 3: this.fm.addr_idkec = res.id; 
                this.disabled.addr_idpro = true;
                this.disabled.addr_idkab = true;
                this.disabled.addr_idkec = true;
                break;
              case 4: this.fm.addr_idkel = res.id; 
                this.disabled.addr_idpro = true;
                this.disabled.addr_idkab = true;
                this.disabled.addr_idkec = true;
                this.disabled.addr_idkel = true;
                break;
            }
          }            
        })
      }
    },

    submitReport(){
      this.readItems();
    },

    search: debounce(function (term) {
      this.term = term;
      this.readItems()
    }, 800),

    readItems () {
      this.loading = true    
      this.loadstart = true  
            
      const params = {        
        q: this.term,        
        jilid_id  :  this.fm.jilid_id,
        idpro:this.fm.addr_idpro,
        idkab:this.fm.addr_idkab,
        idkec:this.fm.addr_idkec,
        idkel:this.fm.addr_idkel,
        sortby:this.sortby,
        expand:'responDtls, propinsi, kabupaten, kecamatan, kelurahan, tps, createdby'
      }

      this.persen = 0;
      model.surveys(params).then(async response => {
        this.items = response.data;
        this.loading = false    
        let totalPage   = response.pagination ? response.pagination.pageCount : 1;
        this.persen = 1/parseInt(totalPage)*100;
        for (var i=2; i<=parseInt(totalPage); i++){
          //this.loading = true
          await model.surveys({...params, ...{page:i}}).then(response => {            
            this.items = [...this.items,...response.data];
            //this.loading = false                                          
          });
          this.persen = i/parseInt(totalPage)*100;
        }          
        this.loadstart = false
      })
    }, 
    
    export2excel(){
      if(this.items.length !== 0){
        var filename = 'Report.';
        filename    += this.jilids.find(x=>x.id===this.fm.jilid_id) ? this.jilids.find(x=>x.id===this.fm.jilid_id).name+'.' : '';           
        filename    += this.$moment().format('DDMMYY.HHmm');
        new Table2Excel('#export table').export(filename);
      } else {
        window.getApp.$emit('showSnackbar', {
            show : true,
            text : 'No Data Result',
            color: 'orange'
        });
      }
    },
  },  
}
</script>
<style>
.tb-normal{    
  border-collapse: collapse;
}
.tb-normal td, .tb-normal th {
  border: 1px solid #ddd;
  padding: 4px 6px;
}
</style>